import '@kaidam/fc-shared/assets/texteditor/shared.css'
import '@kaidam/fc-shared/assets/texteditor/render.css'
import React, { useEffect, FC } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Router as RouterType } from 'router5'
import { RouterProvider } from 'react-router5'
import Loading from './components/system/Loading'

import systemSelectors from '@kaidam/fc-shared/src/frontend/store/selectors/system'
import systemActions from '@kaidam/fc-shared/src/frontend/store/modules/system'
import authActions from './store/modules/auth'
import projectActions from './store/modules/project'
import snackbarActions from './store/modules/snackbar'

import {
  ThunkDispatcher,
} from './types/store'

import Router from './router/Router'
import { user } from 'router/auth'

interface AppProps {
  router: RouterType,
}

const App: FC<React.PropsWithChildren<AppProps>> = ({
  router,
  children,
}) => {
  const dispatch = useDispatch()
  const thunkDispatch = dispatch as ThunkDispatcher
  const initialised = useSelector(systemSelectors.initialised)

  useEffect(() => {
    const initialise = async () => {
      const urlParams = new URLSearchParams(window.location.search)
      const token = urlParams.get('token') || urlParams.get('access_token')
      const verified = urlParams.get('verified')
      await thunkDispatch(authActions.authenticate(token || ''))
      await thunkDispatch(systemActions.initialise())
      await thunkDispatch(projectActions.initialise())
      if(verified) {
        dispatch(snackbarActions.setSuccess('Your email has been verified.'))
      }
      router.start()
    }
    initialise()
  }, [])

  if(!initialised) {
    return (
      <Loading />
    )
  }

  return (
    <RouterProvider router={ router }>
      <Router>
        { children }
      </Router>
    </RouterProvider>
  )
}

export default App
